module.exports = __webpack_public_path__ + "img/homevisit_01.d2ba0af0.svg";